import React from 'react';
import { formatCurrency } from './utils';
import { FileMinus, Ban, ScanBarcode } from 'lucide-react';

const StatCards = ({ missed_charge_amount, discount_total, charge_capture_total }) => {

  return (
      <div className="stat-card-container top-of-table">
        <div className={`stat-card missed`}>
          <div className="icon-block coral">
            <Ban className="stat-icon" />
          </div>
          <div className="stat-info">
            <h3 className="stat-title">Missed Charges</h3>
            <p className="stat-value">{formatCurrency(missed_charge_amount)}</p>
            <p className="stat-text">
              <em>Sum of all charges logged to the treatment sheet within Instinct, but not pushed through to the PVL.</em>
            </p>
          </div>
        </div>

        <div className={`stat-card discount`}>
          <div className="icon-block clay">
            <FileMinus className="stat-icon" />
          </div>
          <div className="stat-info">
            <h3 className="stat-title">Discounted Items</h3>
            <p className="stat-value">{formatCurrency(discount_total)}</p>
            <p className="stat-text">
              <em>Sum of all discounting logged in Cornerstone that violates any of the red flag rules.</em>
            </p>
          </div>
        </div>

        <div className={`stat-card capture`}>
          <div className="icon-block teal">
            <ScanBarcode className="stat-icon" />
          </div>
          <div className="stat-info">
            <h3 className="stat-title">Charge Capture</h3>
            <p className="stat-value">{formatCurrency(charge_capture_total)}</p>
            <p className="stat-text">
              <em>Sum of all charges that were found using the Charge Capture logics to find missed codes in the final PVL.</em>
            </p>
          </div>
        </div>
      </div>
  );
};

export default StatCards;
